"use client";

import { useEffect, useState } from "react";
import useScreenTypeHook from "react-screentype-hook";

/**
 * @param mobile
 * @param tablet
 * @param desktop
 * @param largeDesktop
 * @returns {{isDesktop: boolean, isTablet: boolean, isSmallScreen: boolean, isMobile: boolean, isLargeScreen: boolean, isLargeDesktop: boolean}}
 */
export default function useScreenType({
  mobile = 600,
  tablet = 900,
  desktop = 1200,
  largeDesktop = 1800,
} = {}) {
  const [windowWidth, setWindowWidth] = useState(
    (typeof window !== "undefined" && window?.innerWidth) || 1200
  );
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const isSmallScreen = windowWidth < 900;
  const isLargeScreen = windowWidth >= 900;

  return { isSmallScreen, isLargeScreen };
}
